module.exports = "<p>\n  Redirecting...\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/skyswitch-sso/skyswitch-sso.component.html
// module id = ./src/app/skyswitch-sso/skyswitch-sso.component.html
// module chunks = main